import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import {EXIT_CONFIG} from '../../../models/dialogModels';
import * as animationHelper from "../../../helpers/animationHelper";

class TheEnd extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgressionButton: false,
            icon: {
                src: "",
            },
            screenStatus: "",
            checkComplete: false,
            reviewBtn: {
                show: false,
                label: `${appHelper.getLocaleString("review_label")}`
            },
            clearBtn: {
                show: false,
                label: `${appHelper.getLocaleString("clear_and_start_again_label")}`
            },

            menuBtn: {
                show: false,
                label: `${appHelper.getLocaleString("return_to_menu_label")}`
            },
            exitBtn: {
                show: false,
                label: `${appHelper.getLocaleString("exit_label")}`
            },
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(),this.props.callbacks.getScreenId(),this.props.screenObject.asset_id),
            progressionLabel: `${appHelper.getLocaleString("continue_label")}`,
        };

        this.handleProgression = this.handleProgression.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.disableProgression = this.disableProgression.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.show = this.show.bind(this);
        this.onShowComplete = this.onShowComplete.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.clearResults = this.clearResults.bind(this);
        this.onReview = this.onReview.bind(this);
        this.setDisplay = this.setDisplay.bind(this);
        this.goToMenu = this.goToMenu.bind(this);
        this.setClass = this.setClass.bind(this);
        this.setIconClass = this.setIconClass.bind(this);
        this.exit = this.exit.bind(this);

        this.containerRef = React.createRef();
    }

    componentDidMount() {
        this.getAssets();
        this.setDisplay();
        this.getScreenStatus();
        this.show();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                reviewBtn: {
                    label: `${appHelper.getLocaleString("review_label")}`
                },
                clearBtn: {
                    label: `${appHelper.getLocaleString("clear_and_start_again_label")}`
                },

                menuBtn: {
                    label: `${appHelper.getLocaleString("return_to_menu_label")}`
                },
                exitBtn: {
                    label: `${appHelper.getLocaleString("exit_label")}`
                },
                progressionLabel: `${appHelper.getLocaleString("continue_label")}`,
            });
        }
    }

    componentDidUpdate() {

        if (this.state.checkComplete) {
            this.onComplete();
        }
    }

    getScreenStatus() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    getObjectStatus() {
        if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
            this.onComplete();
        } else {
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)) {
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                } else {
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }
            if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
                this.setState({status: objectConstants.STATUS_COMPLETE, checkComplete: true});
            } else {
                this.setState({checkComplete: true});
            }

        }

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getAssets() {
        if (appHelper.isDefined(this.state.screenObject.icon)) {
            let icon = appHelper.getIconAsset(this.state.screenObject.icon);
            if (appHelper.isDefined(icon) && icon.src.length > 0) {
                this.setState({icon: icon});
            }
        }
    }

    show() {
        let objectRef = this.containerRef.current;
        let params = {
            ele: objectRef,
            duration: objectConstants.SHOW_PANEL_DURATION,
            delay: 0,
            callback: this.getObjectStatus
        };
        animationHelper.showHeight(params);
    }


    onShowComplete() {
        this.setState({isVisible: true, checkComplete: false});
    }


    scrollToTop() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE && screenStatus !== objectConstants.STATUS_COMPLETE) {
            let question = this.refs[`${this.state.screenObject.asset_id}_asset`];
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                if (appHelper.isDefined(scrollTo, true)) {
                    scrollTo(question.offsetTop);
                }
            }, objectConstants.SCROLL_TO);
        }
    }

    onComplete() {
        this.setState({checkComplete: false});
        this.scrollToTop();
        /*let hasNextObject = this.props.callbacks.hasNextObject(this.state.screenObject);
        if(appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)){
            if(!hasNextObject) {
                this.handleProgression();
                this.enableProgression();
            }else{
                this.enableProgression();
            }

        }else{
            this.handleProgression();
        }*/
        //this.enableProgression();
        this.handleProgression();
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    disableProgression() {
        this.setState({showProgressionButton: false});
    }

    handleProgression() {
        let completionData = {
            progression: objectConstants.OBJECT_PROGRESSION_CONTINUE,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            showProgressionButton: false,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
            index: this.props.index
        };

        this.props.callbacks.onObjectComplete(completionData);
        //t

    }

    onProgressionBtnClicked() {
        this.setState({showProgressionButton: false});
        if (this.props.callbacks.hasNextObject(this.props.index)) {
            this.handleProgression();
        } else {
            this.props.callbacks.navigateToNextScreen();
        }
    }

    clearResults() {
        let bite = appHelper.getBiteById(this.props.callbacks.getBiteId());
        this.props.actions.clearBiteUserData(bite).then((userData) => {
            this.props.actions.setSuspendData(userData).then((userData) => {
                this.onReview();
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    goToMenu() {
        this.context.router.push('menu');
    }

    onReview(){
        let bite = appHelper.getBiteById(this.props.callbacks.getBiteId());
        let go_to_screen_id = bite.screens[0].screen_id;
        if(this.props.contentData.experience.bites.length > 1) {
            go_to_screen_id = this.props.contentData.experience.bites[0].screens[0].screen_id;
        }
        this.props.callbacks.goToScreen(go_to_screen_id);
    }

    setDisplay() {
        if (this.state.screenObject.action === objectConstants.END_ACTION_REVIEW) {
            this.setState({
                reviewBtn: Object.assign({}, this.state.reviewBtn, {
                    show: true
                })
            });

        } else if (this.state.screenObject.action === objectConstants.END_ACTION_REVIEW_OR_CLEAR) {
            this.setState({
                reviewBtn: Object.assign({}, this.state.reviewBtn, {
                    show: true
                }),
                clearBtn: Object.assign({}, this.state.clearBtn, {
                    show: true
                })
            });
        } else if (this.state.screenObject.action === objectConstants.END_ACTION_CLEAR) {
            this.setState({
                clearBtn: Object.assign({}, this.state.clearBtn, {
                    show: true
                })
            });

        } else if (this.state.screenObject.action === objectConstants.END_ACTION_RETURN_TO_MENU) {
            this.setState({
                menuBtn: Object.assign({}, this.state.menuBtn, {
                    show: true
                })
            });

        } else if (this.state.screenObject.action === objectConstants.END_ACTION_EXIT) {
            this.setState({
                exitBtn: Object.assign({}, this.state.exitBtn, {
                    show: true
                })
            });

        }

    }

    setClass() {
        if (appHelper.isDefined(this.state.screenObject.class_name) && this.state.screenObject.class_name.length > 0) {
            return this.state.screenObject.class_name;
        } else {
            return "standard-block";
        }
    }

    setIconClass() {
        return this.state.icon.src.length > 0 ? 'has-icon' : '';
    }

    exit() {
        this.props.actions.setNewDialog(EXIT_CONFIG);
    }


    render() {
        return (
            <div className="a-c" ref={this.containerRef}>
                <div className={`object-container`} ref={`${this.state.screenObject.asset_id}_asset`}>
                    <div className={`${this.setClass()}`}>
                        <div className={`paragraph-content-wrapper ${this.setIconClass()}`}>
                            {this.state.icon.src.length > 0
                                ?
                                <div className="icon-column">
                                    <img src={this.getImagePath(this.state.icon.src)} alt=""/>
                                </div>
                                :
                                null
                            }
                            <div className="content-column">
                                {
                                    this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0
                                        ? <h4 className={objectConstants.DEFAULT_HEADING_CLASS}  dangerouslySetInnerHTML={{__html:this.state.locale.label}} />
                                        : null
                                }
                                {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                    ?
                                    <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                    : null
                                }
                            </div>
                        </div>
                        <div className="inline-list text-center">
                        {this.state.reviewBtn.show
                            ?
                            <div className="inline-item">
                                <input className={`btn btn-lg guroo-btn action-btn`} type="button" value={this.state.reviewBtn.label} onClick={this.onReview}/>
                            </div>
                            : null
                        }
                        {this.state.clearBtn.show
                            ?
                            <div className="inline-item">
                                <input className={`btn btn-lg guroo-btn action-btn`} type="button" value={this.state.clearBtn.label}
                                      onClick={this.clearResults}/>
                            </div>
                            : null
                        }
                        {this.state.menuBtn.show
                            ?
                            <div className="inline-item">
                                <input className={`btn btn-lg guroo-btn action-btn`} type="button" value={this.state.menuBtn.label}
                                      onClick={this.onProgressionBtnClicked}/>
                            </div>
                            : null
                        }
                            {this.state.exitBtn.show
                                ?
                                <div className="inline-item">
                                    <input className={`btn btn-lg guroo-btn action-btn`} type="button" value={this.state.exitBtn.label}
                                           onClick={this.exit}/>
                                </div>
                                : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

TheEnd.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    index: PropTypes.number,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
};

TheEnd.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TheEnd);



/** WEBPACK FOOTER **
 ** ./src/components/objects/theEnd/TheEnd.js
 **/